var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sidebar"}},[_c('div',[_c('MuteSymbol')],1),_c('h1',[_vm._v("Breakout!")]),_c('SidebarContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }